export default "__VITE_ASSET__DcrKZb0p__"